module.exports = __webpack_public_path__ + "static/media/data.63c0abd8.svg";